import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectBankStorageUsage } from 'scenes/ProjectBank/services/getProjectBankStorageUsage.service';

/**
 * Loads the bank storage usage of the project's business for the sidebar's
 * storage section (see SidebarStorage). The slice keeps the latest answer
 * and its status; a failure leaves the section saying so.
 * @param {string} projectId
 */
export const loadProjectBankStorageUsage = createAsyncThunk(
  'projectBank/loadProjectBankStorageUsage',
  async (projectId) => {
    const usage = await getProjectBankStorageUsage(projectId);
    return { projectId, ...usage };
  }
);
